export const NO_RELEVANT_TEMPLATES_STRING = 'No relevant templates were found.';
export const RELEVANT_TEMPLATES_TAB_NAME = 'Relevant Templates';
export const RELEVANT_TEMPLATES_DESCRIPTION_STRING =
  'Review and update relevant templates when schemas are modified.';
export const COLLECTIONS_FILTER_STRING = 'Collection';

export const RELEVANT_TEMPLATES_SEARCH_DEBOUNCE_MS = 250;

export interface RelevantTemplatesHeaderInfo {
  name: string;
}

export const HEADER_COLUMNS: Record<string, RelevantTemplatesHeaderInfo> = {
  template: {
    name: 'Relevant template',
  },
  type: {
    name: 'Type',
  },
  templateCollection: {
    name: 'Collection',
  },
  modifiedAt: {
    name: 'Last modified',
  },
  relevantTables: {
    name: 'Relevant tables',
  },
};
